export type ExternalProviders = 'ebox';

export function isValidExternalProviders(provider: string): provider is ExternalProviders {
  return ['ebox'].includes(provider);
}
